import $ from "jquery";

class ScrollHandler {
    constructor() {
        this.cc_scroll_position = 0;
        // this.scroll_pos = 0;
        $(document).scroll(() => this.handleScroll());
    }

    handleScroll() {
        this.cc_scroll_position = $(document).scrollTop();
        if (this.cc_scroll_position > 100) {
            $(".site-header").addClass("is-scrolled");
        } else {
            $(".site-header").removeClass("is-scrolled");
        }
        /*this.scroll_pos = $(document).scrollTop();
        if (this.scroll_pos > 1200) {
            $("body").addClass("scroll-down-section04");
        } else {
            $("body").removeClass("scroll-down-section04");
        }*/
    }
}

export default ScrollHandler;